import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import PetRegistration from "./PetRegistration";
import UserRegistration from "./UserRegistration";

const Registration = () => {
  const [selectedTab, setSelectedTab] = useState("User");
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    setSelectedUser(null);
  }, []);

  useEffect(() => {
    if (!selectedUser) return;
    if (selectedUser) setSelectedTab("Pet");
  }, [selectedUser]);

  return (
    <div className="Login-main-container">
      <Grid container className="jus-cen">
        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          lg={6}
          xl={6}
          className="back-white p10 br10"
        >
          <div className="just-cen">
            <div className="flex-row">
              <div
                className="ph10pv3"
                // onClick={() => {
                //   if (selectedUser) return;
                //   setSelectedTab("User");
                // }}
              >
                <div className="flex-center pet-det-sel-tab">
                  {selectedTab} Registration
                </div>
              </div>
              {/* <div className="ph10pv3" onClick={() => setSelectedTab("Pet")}>
                <div
                  className={`flex-center cursor ${
                    selectedTab === "Pet"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Pet
                </div>
              </div> */}
            </div>
          </div>
          <div className="scroll-85vh">
            {selectedTab === "User" ? (
              <UserRegistration
                setSelectedUser={setSelectedUser}
                setSelectedTab={setSelectedTab}
              />
            ) : null}
            {selectedTab === "Pet" ? (
              <PetRegistration
                selectedUser={selectedUser}
                setSelectedUser={setSelectedUser}
              />
            ) : null}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Registration;
